<div class="timeline-content container small">
    <div class="timeline-center-line"></div>
    <ng-content></ng-content>
</div>